package fr.manyverse.app.infrastructure.haptic

import androidx.compose.runtime.Composable

@Composable
actual fun rememberHapticVibrator(): (amplitude: Int, durationMs: Long) -> Unit = { _, _ -> }
